// extracted by mini-css-extract-plugin
module.exports = {"logo":"ClientLogo_logo__Xyhxt"};